import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { choiceTypeObject } from '../../../../common/propTypes';
import { Flex } from '@instructure/quiz-common';
import ChoiceTypeTable from '../../shared/ChoiceTypeTable';
import { Text } from '@instructure/ui-text';
import t from '@instructure/quiz-i18n/es/format-message';
export var ChoiceTypeWithInfo = /*#__PURE__*/function (_Component) {
  function ChoiceTypeWithInfo() {
    var _this;
    _classCallCheck(this, ChoiceTypeWithInfo);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChoiceTypeWithInfo, [].concat(args));
    _defineProperty(_this, "renderTable", function () {
      var _this$props = _this.props,
        itemId = _this$props.itemId,
        choices = _this$props.choices,
        index = _this$props.index;
      var tableId = "".concat(itemId, "_").concat(index, "_choiceGroup");
      var tableContainerSizeStyles = {};
      return /*#__PURE__*/React.createElement(ChoiceTypeTable, {
        itemId: tableId,
        choices: choices,
        tableContainerStyles: tableContainerSizeStyles
      });
    });
    _defineProperty(_this, "renderEmptyRequirement", function () {
      return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Flex.Item, {
        padding: "medium none none none"
      }, /*#__PURE__*/React.createElement(Text, null, t('There are no entries for this requirement.'))));
    });
    _defineProperty(_this, "render", function () {
      var _this$props2 = _this.props,
        headLine = _this$props2.headLine,
        choices = _this$props2.choices;
      var areThereChoices = Array.isArray(choices) && choices.length > 0;
      return /*#__PURE__*/React.createElement(Flex, {
        direction: "column",
        justifyItems: "start"
      }, /*#__PURE__*/React.createElement(Flex.Item, {
        overflowY: "visible",
        shouldGrow: true,
        shouldShrink: true
      }, /*#__PURE__*/React.createElement(Flex, {
        direction: "column",
        justifyItems: "start"
      }, /*#__PURE__*/React.createElement(Flex.Item, {
        shouldShrink: true,
        padding: "none none none none",
        overflowY: "hidden"
      }, /*#__PURE__*/React.createElement(Flex, {
        direction: "row",
        alignItems: "start"
      }, /*#__PURE__*/React.createElement(Flex.Item, {
        shouldShrink: true,
        shouldGrow: true,
        margin: "none none none none"
      }, headLine))), /*#__PURE__*/React.createElement(Flex.Item, {
        shouldShrink: true,
        padding: "none none medium none"
      }, areThereChoices ? _this.renderTable() : _this.renderEmptyRequirement()))));
    });
    return _this;
  }
  _inherits(ChoiceTypeWithInfo, _Component);
  return _createClass(ChoiceTypeWithInfo);
}(Component);
_defineProperty(ChoiceTypeWithInfo, "propTypes", {
  itemId: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  choices: choiceTypeObject.isRequired,
  headLine: PropTypes.node,
  styles: PropTypes.object
}.isRequired);